export default class RegistrationRequiredDocument {

    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.registeringChannelId = jsonResponse["registering-channel-id"];
        this.documentType = jsonResponse["document-type"];
    }

    static toJson = function(item){
        let jsonObj = {};
        jsonObj["id"] = item.id;
        jsonObj["registering-channel-id"] = item.registeringChannelId;
        jsonObj["document-type"] = item.documentType;
        return jsonObj;
    };

}